import React from 'react';

type BuildInfo = {
  version: string;
  sha?: string;
  builtAt?: string;
  timeZone?: string;
};

const VersionStamp: React.FC = () => {
  const [version, setVersion] = React.useState<string | null>(null);

  React.useEffect(() => {
    let mounted = true;
    fetch('/version.json', { cache: 'no-cache' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data: BuildInfo | null) => {
        if (!mounted || !data || !data.version) return;
        setVersion(data.version);
      })
      .catch(() => {
        // 何もしない（非表示）
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!version) return null;

  return (
    <div
      className="fixed bottom-2 right-2 text-[10px] text-gray-500 opacity-70 pointer-events-none select-none z-[5]"
      aria-label="App version"
    >
      {version}
    </div>
  );
};

export default VersionStamp;

